import axios from 'axios';
import React from 'react';
import PressReleaseLayout from 'components/PressReleaseLayout';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';

import configData from '../config.json';
import { msalInstance } from '../authConfig';

const Preview = () => {
  let previewJSON = JSON.parse(window.localStorage.getItem('pageData'));
  let date = previewJSON.Release.split('-');

  const PREVIEW_SCOPES = ['api://39b64b04-e385-4232-a4e2-604367e2d849/.default'];

  // This page is opened as its own popup window (see sendDataToNewTab in
  // NewData/EditUser), so it can't assume the opener's MSAL account/session
  // is present here (sessionStorage-backed cache is only snapshotted once,
  // at window.open time, and a reused/stale popup can outlive that). Fall
  // back to an interactive login when no account/silent token is available
  // instead of letting acquireTokenSilent throw uncaught.
  const getAccessToken = async () => {
    const account = msalInstance.getAllAccounts()[0];
    if (!account) {
      const loginResult = await msalInstance.loginPopup({ scopes: PREVIEW_SCOPES });
      return loginResult.accessToken;
    }
    try {
      const authResult = await msalInstance.acquireTokenSilent({
        scopes: PREVIEW_SCOPES,
        account
      });
      return authResult.accessToken;
    } catch (err) {
      const authResult = await msalInstance.acquireTokenPopup({
        scopes: PREVIEW_SCOPES,
        account
      });
      return authResult.accessToken;
    }
  };

  const previewPDF = async (e) => {
    try {
      const accessToken = await getAccessToken();
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      };
      const response = await axios.get(
        `${configData.previewPDF}?year=${previewJSON.Year}&filename=${previewJSON.FileName}`,
        config
      );
      const url = response?.data?.url;
      if (!url) {
        console.error('[previewPDF] No pre-signed URL returned');
        alert('プレビューの読み込みに失敗しました。');
        return;
      }
      window.open(
        url,
        'Popup',
        'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30'
      );
    } catch (err) {
      console.error('[previewPDF] Failed:', err);
      alert('プレビューの読み込みに失敗しました。');
    }
  };

  return (
    <PressReleaseLayout>
      <div>
        <h3>
          {date[0]}年{date[1]}月{date[2]}日
        </h3>
        <p>
          <a
            className="pdf latest-story"
            href="javascript:void(0)"
            onClick={(e) => previewPDF(e)}
            style={{
              whiteSpace: 'pre-wrap',
              overflowWrap: 'anywhere',
              color: '#0056b3',
              textDecoration: 'underline'
            }}>
            {JSON.parse(window.localStorage.getItem('pageData')).Title}
          </a>
        </p>
      </div>
    </PressReleaseLayout>
  );
};

export default Preview;
